import { render, staticRenderFns } from "./folder_class_selector.vue?vue&type=template&id=3496e44a&"
import script from "./folder_class_selector.vue?vue&type=script&lang=js&"
export * from "./folder_class_selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports